<template>
	<div>
		
		<div class="container-fluid ss-signup-banner mt-0">
			<div class="row">
				<div class="col">
					<div class="ss-signup-body">
						<h1 :class="[stepheading.icon, 'ss-icon']"></h1>
						<h1 class="ss-heading" v-html="$parseHtml(stepheading.heading)"></h1>
						<h4 class="ss-subheading" v-html="$parseHtml(stepheading.subHeading)"></h4>
					</div>
				</div>
			</div>
		</div>

		<div class="container-fluid">
			<div class="row">
				<div class="col">
					
					<transition name="list">
						<router-view></router-view>
					</transition>
					
				</div>
			</div>
		</div>
		

	</div>
</template>

<script>
	
	export default {
		data() {
			return {
				step: 1
			}
		},

		components: {			
			
		},

		created() {			
			
			
		},

		methods: {
			
		},

		computed: {
			stepheading() {
				let step;
				switch (this.$route.meta.step) {
					case 1:
						
						step = this.$store.state.steps.one;
						break;
					case 2:
						step = this.$store.state.steps.two;
						break;
					case 3:
						step = this.$store.state.steps.three;
						break;
					case 4:
						step = this.$store.state.steps.four;
						break;
					case 5:
						step = this.$store.state.steps.five;
						break;
					
					default:
						break;
				}
				return step;
			}
				
		}
	}
</script>

<style>
	.banner {
		margin-top: 10px;
		margin-bottom: 0;
		background: #cc6600;
		padding: 20px;
		color: white;
	}
	.banner h1 {
		color: white;
		margin-top: 0;
		margin-bottom: 5px;
	}
	.banner h4 {
		color: #ebebeb;
		margin-bottom: 25px;
	}
	
	.has-error input,
	.has-error select {
		border-color: red;
	}

	
</style>
